import { CommonModule } from '@angular/common'
import { Component, input } from '@angular/core'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, Grid } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { GridColumnGroupComponent } from '../../shared/reusable-components/grid-column-group/grid-column-group.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { GridSelectionCalculationComponent } from '../../shared/reusable-components/grid-selection-calculation/grid-selection-calculation.component'
import { bindPurchasedMaterialTab, PurchasedMaterialFilters, purchasedMaterialScopeKey } from './purchased-material-filters'

interface QualityCard {
    key: string
    title: string
    count: number
    amount: number | null
    examplesTruncated: boolean
}

interface QualityExample {
    issueKey: string
    invoiceNumber: string
    vendor: string
    invoiceDate: string
    issue: string
    description: string
}

interface QualityPayload {
    exampleLimit: number
    cards: QualityCard[]
    examples: QualityExample[]
}

@Component({
    selector: 'app-purchased-materials-quality',
    templateUrl: './purchased-materials-quality.component.html',
    standalone: true,
    imports: [
        CommonModule,
        ActionToolbarCount,
        GridExportComponent,
        GridColumnGroupComponent,
        WjGridModule,
        WjGridFilterModule,
        GridSelectionCalculationComponent,
    ],
})
export class PurchasedMaterialsQualityComponent extends BaseComponent {
    filters = input.required<PurchasedMaterialFilters>()
    active = input(false)

    exampleGrid: Grid<QualityExample>
    cards: QualityCard[] = []
    examples: QualityExample[] = []
    exampleLimit = 200
    selected = ''

    constructor() {
        super()
        this.exampleGrid = new Grid<QualityExample>(this.services).wrapColumnHeaders()
        bindPurchasedMaterialTab(
            this.filters,
            this.active,
            filters => purchasedMaterialScopeKey(filters, true),
            () => this.clear(),
            filters => this.load(filters),
        )
    }

    get selectedCard(): QualityCard | null {
        return this.cards.find(card => card.key === this.selected) ?? null
    }

    show(key: string) {
        this.selected = key
        this.exampleGrid.items = this.examples.filter(row => row.issueKey === key)
    }

    private clear() {
        this.cards = []
        this.examples = []
        this.selected = ''
        this.exampleGrid.items = []
    }

    private load(filters: PurchasedMaterialFilters) {
        this.cancelableRequest(
            'dataQuality',
            true,
            this.services.data
                .load(true, true, this.services.data.post('/api/PurchasedMaterials/GetDataQuality', filters))
                .subscribe({
                    next: result => {
                        const payload = result[0] as QualityPayload
                        this.cards = payload.cards ?? []
                        this.examples = payload.examples ?? []
                        this.exampleLimit = payload.exampleLimit || 200
                        const first = this.cards.find(card => card.count > 0) ?? this.cards[0]
                        this.show(first?.key ?? '')
                    },
                }),
        )
    }
}
